<script setup>
import { SwButton } from '@getswish/design-library-web';
import { useI18n } from 'vue-i18n';
import CustomIcon from '@/_company/components/CustomIcon.vue';
import ModalLayout from '@/_company/components/ModalLayout.vue';

defineProps({
  certificate: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['onConfirm', 'onCancel']);

const { t } = useI18n();
</script>

<template>
  <modal-layout @onClose="emit('onCancel')" size="medium" class="view-modal">
    <template v-slot:header>
      <h2>{{ t('company.certificates.viewModal.heading') }}</h2>
    </template>

    <template v-slot:body>
      <p>{{ t('company.certificates.viewModal.text') }}</p>

      <div class="certificate-wrapper">
        <span>{{ certificate }}</span>
      </div>
    </template>

    <template v-slot:footer>
      <SwButton
        :label="$t('company.certificates.download')"
        left-icon="download"
        class="button"
        @click="emit('onConfirm')"
      />
      <SwButton
        :label="$t('company.certificates.viewModal.cancelButton')"
        variant="secondary"
        class="button"
        @click="emit('onCancel')"
      />
    </template>
  </modal-layout>
</template>

<style lang="scss" scoped>
.view-modal {
  p {
    border-top: 1px solid $primary-border;
    padding-top: $space-16;
    color: $primary-text;
  }

  .certificate-wrapper {
    border-radius: 6px;
    background: $secondary-background;
    padding: $space-16;
    margin: $space-24 0;
    max-height: 200px;
    overflow: scroll;
    text-align: left;

    @include tablet-large {
      max-height: 400px;
    }

    span {
      margin: 0;
      color: $primary-text;
      font-family: monospace;
      font-size: 0.875rem;
      line-height: 1.3;
      white-space: pre;
    }
  }

  .button {
    margin-bottom: $space-16;
  }
}
</style>
